export default __webpack_public_path__ + "static/media/ico-download.9b2f2bc4.svg";